import { COUNTRY_CODES } from '~/config/constants';

const localeConfig = {
  cs: {
    dateFormat: 'dd. MM. yyyy',
    dateTimeFormat: 'dd. MM. yyyy HH:mm',
    rangeSeparator: ' - ',
  },
  de: {
    dateFormat: 'dd. MM. yyyy',
    dateTimeFormat: 'dd. MM. yyyy HH:mm',
    rangeSeparator: ' - ',
  },
  en: {
    dateFormat: 'MM/dd/yyyy',
    dateTimeFormat: 'MM/dd/yyyy HH:mm',
    rangeSeparator: ' to ',
  },
  gb: {
    dateFormat: 'dd/MM/yyyy',
    dateTimeFormat: 'dd/MM/yyyy HH:mm',
    rangeSeparator: ' to ',
  },
  nl: {
    dateFormat: 'dd-MM-yyyy',
    dateTimeFormat: 'dd-MM-yyyy HH:mm',
    rangeSeparator: ' - ',
  },
  pl: {
    dateFormat: 'dd. MM. yyyy',
    dateTimeFormat: 'dd. MM. yyyy HH:mm',
    rangeSeparator: ' - ',
  },
  rs: {
    dateFormat: 'dd. MM .yyyy',
    dateTimeFormat: 'dd. MM .yyyy HH:mm',
    rangeSeparator: ' - ',
  },
  sk: {
    dateFormat: 'dd. MM. yyyy',
    dateTimeFormat: 'dd. MM. yyyy HH:mm',
    rangeSeparator: ' - ',
  },
};

const defaultState = {
  country: 'cz',
  language: 'cz',
  dateFormats: {
    dateFns: 'dd. MM. yyyy',
    elementUi: 'dd. MM. yyyy',
    rangeSeparator: ' - ',
  },
  dateTimeFormats: {
    dateFns: 'dd. MM. yyyy HH:mm',
  },
};

const mutations = {
  setEnvVar(state, { name, value }) {
    state[name] = value;
  },
  setDateTimeFormats(state, locale) {
    const config = localeConfig[locale] || localeConfig.cs;
    state.dateFormats = {
      ...state.dateFormats,
      dateFns: config.dateFormat,
      elementUi: config.dateFormat,
      rangeSeparator: config.rangeSeparator,
    };

    state.dateTimeFormats = {
      ...state.dateTimeFormats,
      dateFns: config.dateTimeFormat,
    };
  },
};

const actions = {
  setLangAndCountry({ commit }, value) {
    commit('setEnvVar', {
      name: 'country',
      value,
    });

    commit('setEnvVar', {
      name: 'language',
      value,
    });

    commit('setDateTimeFormats', value);
  },
};

const getters = {
  env: state => state,
  dateFormats: state => state.dateFormats,
  dateTimeFormats: state => state.dateTimeFormats,
  country: state => state.country,
  language: state => state.language,
  isCzech: state => COUNTRY_CODES[state.country.toUpperCase()] === COUNTRY_CODES.CS,
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
